module.exports = __webpack_public_path__ + "img/公司官网_一体化 手机端.740b0702.png";